import React from 'react';
import { FixedContentProps } from './Page.types';

const FixedFooter = ({ children }: FixedContentProps) =>
  React.cloneElement(children, {});

FixedFooter.displayName = 'Page.FixedFooter';

export { FixedFooter };
